export function serializeColumnState(visibleColumns) {
	if (!visibleColumns?.length) return { visible: [] };
	return {
		visible: visibleColumns.map(column => column.value)
	};
}

export function normalizeColumnStateForCompare(columnState, defaultColumns) {
	const visible =
		columnState?.visible?.length > 0
			? columnState.visible
			: serializeColumnState(defaultColumns || []).visible;

	return {
		visible: [...visible].sort()
	};
}

export function deserializeColumnState(
	columnState,
	tableColumnsOptions,
	defaultColumns
) {
	const schemaValues = new Set(
		(tableColumnsOptions || []).map(column => column.value)
	);
	const savedVisible = columnState?.visible;

	if (!savedVisible?.length) {
		return defaultColumns || [];
	}

	const optionByValue = new Map(
		(tableColumnsOptions || []).map(column => [column.value, column])
	);

	return savedVisible
		.filter(value => schemaValues.has(value))
		.map(value => optionByValue.get(value))
		.filter(Boolean);
}

export function columnsMatch(
	savedColumnState,
	visibleColumns,
	tableColumnsOptions
) {
	const saved = deserializeColumnState(
		savedColumnState,
		tableColumnsOptions,
		[]
	).map(column => column.value);
	const current = (visibleColumns || []).map(column => column.value);

	if (saved.length !== current.length) return false;
	const currentSet = new Set(current);
	return saved.every(value => currentSet.has(value));
}
